import { cn } from "@/lib/utils";
import { useAppSelector } from "@/store/hooks";

export function useP2PInputClass() {
  const { theme } = useAppSelector((state) => state.ui);

  return cn(
    "w-full px-4 py-3 rounded-lg text-sm transition-all h-14",
    "focus:outline-none focus:ring-2 focus:ring-primary/40",

    theme === "dark"
      ? "bg-muted border border-border text-foreground placeholder:text-muted-foreground"
      : "bg-white border border-gray-200 text-gray-900 placeholder:text-gray-400",
  );
}
